import { render, staticRenderFns } from "./SecondStepContainer.vue?vue&type=template&id=9ccc6126&lang=html&"
import script from "./SecondStepContainer.vue?vue&type=script&lang=ts&"
export * from "./SecondStepContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports